import { CodeBook } from "@king-ict/eupisi-ui/models";

export const filterAndFindInstitution = (
  institutions: CodeBook[] | undefined,
  selectedId: number | null
): [CodeBook[], CodeBook | undefined] => {
  return (
    institutions?.reduce<[CodeBook[], CodeBook | undefined]>(
      ([filtered, selected], institution) => {
        if (institution.id === selectedId) {
          return [filtered, institution];
        }
        return [[...filtered, institution], selected];
      },
      [[], undefined]
    ) ?? [[], undefined]
  );
};
